<template>
  <div class="data-box">
    <p class="data-title">数据一览</p>
    <div class="data-inside">
      <div class="grid-item" v-for="(value, key) in props.obj" :key="key">
        <p>{{ key === "count" ? "全部" : key }}</p>
        <p>{{ value }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  obj: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>

<style scoped lang="scss">
.data-box {
  width: 343px;
  height: 332px;
  border-radius: 12px;
  padding: 0px 14px 14px 14px;
  // background: linear-gradient(
  //   83.62deg,
  //   #c0d7fa 15.91%,
  //   #c6d5f9 36.81%,
  //   #f2f7fe 47.42%
  // );
  background-color: #2A64EA;
  background-image: url("@/assets/Rectangle 1051.png");
  // background-size:100%;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  
  .data-title {
    width: 72px;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    margin-left: 17px;
    position: absolute;
    margin-top: 4px;
  }
  .data-inside {
    width: 316px;
    height: 264px;
    // border: 1px solid rgb(43, 255, 0);
    border-radius: 10px;
    background-color: #ffffff;
    margin-top: 52px;
    display: grid;
    grid-template-columns: auto auto auto;

    .grid-item {
      width: 105px;
      height: 88px;

      border: 1px solid #d5e0f9;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #333333;
      //   line-height:88px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      > p:nth-of-type(1) {
        color: #333333;
        font-size: 14px;
        font-weight: 400;
      }
      > p:nth-of-type(2) {
        margin-top: 2px;
        color: #fc643f;
        font-size: 18px;
        font-weight: 700;
      }
    }
    .grid-item:nth-of-type(1),
    .grid-item:nth-of-type(2),
    .grid-item:nth-of-type(3),
    .grid-item:nth-of-type(4),
    .grid-item:nth-of-type(5),
    .grid-item:nth-of-type(6) {
      border-top: none;
      border-right: none;
    }
    .grid-item:nth-of-type(7),
    .grid-item:nth-of-type(8),
    .grid-item:nth-of-type(9) {
      border-bottom: none;
      border-right: none;
      border-top: none;
    }
    .grid-item:nth-of-type(1),
    .grid-item:nth-of-type(4),
    .grid-item:nth-of-type(7) {
      border-left: none;
    }
  }
}
</style>